import { Routes } from '@angular/router';
import { LoggedLayout } from './layouts/global/logged/logged-layout';
import { OfflineLayout } from './layouts/global/offline/offline-layout';
import {AuthGuard} from './core/guards/auth.guard';
import {tenantKeyGuard} from './core/guards/tenant-key.guard';
export const routes: Routes = [

  {
    path: '',
    component: LoggedLayout,
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/common/logged/common-logged-module').then((m) => m.CommonLoggedModule),
  },

  // Routes pour utilisateurs non connectés
  {
    path: 'login',
    component: OfflineLayout,
    loadChildren: () => import('./modules/common/offline/pages/login/auth.routes')
  },

  {
    path: 'auth/login',
    component: OfflineLayout,
    loadChildren: () => import('./modules/common/offline/pages/login/auth.routes')
  },


  // Route pour les pages hors connexion (si nécessaire)
  {
    path: 'off',
    component: OfflineLayout,
    loadChildren: () => import('./modules/common/offline/common-offline-module').then((m) => m.CommonOfflineModule),
  },


  // HealthBoard (VGS) — cible des QRcodes collés physiquement sur les pièces.
  // URL GRAVÉE dans les autocollants : elle ne doit jamais changer. Pas de layout
  // ni de guard : la page ne rend rien, elle aiguille vers la fiche de la réserve
  // (ou vers le login en mémorisant la destination). Enregistrée à la racine,
  // hors module, exactement comme dans le front VGS legacy.
  // `tenantKeyGuard(['vgs'])` : en VGE/VGI la route existe mais ne mène nulle part
  // (renvoi tableau de bord) — HealthBoard n'y existe pas.
  {
    path: 'ficheHealthBoard/:ido/:id',
    canActivate: [tenantKeyGuard(['vgs'])],
    loadComponent: () => import('./modules/GPAnet/pages/ficheHealthBoard/ficheHealthBoard.page').then((m) => m.FicheHealthBoardPage),
  },

  { path: '**', loadComponent: () => import('./modules/common/offline/pages/notfound/notfound').then((m) => m.Notfound) }

];
